const OTHER = "Other";

export const compareVendorTypeNames = (a, b) => {
  if (a === OTHER && b === OTHER) return 0;
  if (a === OTHER) return 1;
  if (b === OTHER) return -1;
  return a.toLowerCase().localeCompare(b.toLowerCase());
};

export const sortVendorTypes = (types, getName = (t) => t.name) =>
  (types ?? [])
    .slice()
    .sort((a, b) => compareVendorTypeNames(getName(a), getName(b)));
